import React, { useState } from 'react';
import AddContributionModal from '../modals/AddContributionModal';

const NotableContributionsSection = ({ isEditing, contributions = [], onUpdateContributions, title = "NOTABLE CONTRIBUTION" }) => {
  const [showContributionModal, setShowContributionModal] = useState(false);

  const handleAddContribution = (contributionData) => {
    const newContribution = {
      id: Date.now(),
      ...contributionData
    };
    onUpdateContributions([...contributions, newContribution]);
    setShowContributionModal(false);
  };

  const handleRemoveContribution = (contributionId) => {
    const updatedContributions = contributions.filter(contribution => contribution.id !== contributionId);
    onUpdateContributions(updatedContributions);
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">{title}</h2>
        {isEditing && (
          <button
            onClick={() => setShowContributionModal(true)}
            className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
          >
            + Add
          </button>
        )}
      </div>

      <div className="space-y-4">
        {contributions.length === 0 && (
          <div className="p-4 text-sm text-gray-500 border border-dashed border-gray-300 rounded-md">
            No notable contributions added yet.
          </div>
        )}
        
        {contributions.map((contribution) => (
          <div
            key={contribution.id}
            className="bg-[#F8F9FB] border border-[#D6DBEA] p-4 rounded-lg flex items-center justify-between"
          >
            <div className="text-[#222A35] text-[16px] font-medium">
              {contribution.text}
            </div>
            {isEditing && (
              <button
                onClick={() => handleRemoveContribution(contribution.id)}
                className="w-8 h-8 bg-[#FF4D4F1A] border border-[#FF4D4F] rounded-full flex items-center justify-center ml-4"
              >
                <span className="text-[#FF4D4F] text-sm font-bold">×</span>
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Contribution Modal */}
      {showContributionModal && (
        <AddContributionModal
          onClose={() => setShowContributionModal(false)}
          onAdd={handleAddContribution}
        />
      )}
    </div>
  );
};

export default NotableContributionsSection; 